export const CSS_VARIABLE_PREFIX = '--custom-color-';
